$(function(){

    $('.facet-filters__label').click(function(){
        $('.sort_list').toggle();
        $(this).next().next('.select').find('.svg-wrapper').toggleClass('open');
    })


   $('.sort_list li').on('click', function() {
        const value = $(this).attr('value');
        const nowUrl = new URL(window.location.href);
        nowUrl.searchParams.set('sort_by', value);
        window.location.href = nowUrl.toString();
    });

})